<template>
  <div class="modal-mask" @mousedown.self.stop="closeModal">
    <div class="modal" @click.stop>
      <div class="modal__head">
        <h3 class="modal__title">Настройка структуры</h3>
        <div class="close" @click.stop="closeModal">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
            <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
      </div>
      <div class="modal__body">
        <div class="mb-20">
          <AppMessage type="warning">
            Будьте внимательны при установке типов! Иерархия отделов должна соблюдаться!<br>
            Главный отдел (ИНТЕКС) может иметь в подчинении Исполнительного директора, а также напрямую Отделы и Отделения.<br>
            Далее в таком порядке: Исполнительный директор > Директор > Отделение > Отдел > Секция > Сектор.
          </AppMessage>
        </div>
        <div class="page__row">
          <div class="page__item input-item">
            <AppSelect title="Отдел"
                       placeholder="Выберите отдел"
                       width="100%"
                       :value="state.department"
                       :options="departmentList"
                       @value-changed="setDepartment"
            />
          </div>
        </div>
        <div class="page__row mb-60">
          <div class="page__item input-item">
            <AppSelect title="Вышестоящий отдел"
                       placeholder="Выберите отдел"
                       width="100%"
                       :value="state.parentDepartment"
                       :options="departmentList"
                       @value-changed="setParent"
            />
          </div>
          <div class="page__item input-item">
            <AppSelect title="Тип отдела"
                       placeholder="Выберите тип отдела"
                       width="100%"
                       :value="state.type"
                       :options="state.typeList"
                       @value-changed="setType"
            />
          </div>
        </div>
        <div class="page__buttons">
          <div class="page__item">
            <AppButton title="Сохранить"
                       type="main"
                       @click.native="updateDepartment"
            />
          </div>
          <div class="page__item">
            <AppButton title="Отмена"
                       type="alt"
                       @click.native="closeModal"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppSelect from '@/components/page/input/AppSelect'
import AppButton from '@/components/page/button/AppButton'
import AppMessage from '@/components/page/text/AppMessage'
export default {
  name: 'department-settings-modal',
  components: {
    AppMessage,
    AppButton,
    AppSelect
  },
  props: {
    state: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    departmentList () {
      return this.$store.getters['[dictionaries] usersDepartmentList']
    }
  },
  methods: {
    loadOptions () {
      this.$store.dispatch('[dictionaries] getDepartmentList')
    },
    setDepartment (department) {
      this.$store.commit('[department-tree] SET_SETTINGS_DEPARTMENT', department)
    },
    setParent (department) {
      this.$store.commit('[department-tree] SET_SETTINGS_PARENT', department)
    },
    setType (type) {
      this.$store.commit('[department-tree] SET_SETTINGS_TYPE', type)
    },
    closeModal () {
      this.$store.dispatch('[department-tree] closeSettingsModal')
    },
    updateDepartment () {
      this.$store.dispatch('[department-tree] updateDepartmentStructurePlace')
    }
  },
  mounted () {
    this.loadOptions()
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.modal-mask {
  overflow: auto;
  align-items: flex-start;
  padding-top: 10vh;
}

.modal {
  max-width: 910px;

  &__body {
    width: 100%;
  }
}

.page__buttons {
  display: flex;
  justify-content: center;
}
</style>
